import React from 'react';
import PageLayout from './PageLayout.js';
import Button from './Button.js';
import { ArrowLeft } from 'lucide-react';

const FormLayout = ({
  title,
  icon,
  onBack,
  backLabel = 'Back',
  onSubmit,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  onCancel,
  loading = false,
  children,
  maxWidth = 'max-w-4xl',
}) => {
  return (
    <PageLayout title={title} icon={icon} maxWidth={maxWidth}>
      {onBack && (
        <Button
          variant="ghost"
          size="sm"
          icon={ArrowLeft}
          onClick={onBack}
          className="mb-4 -ml-2"
        >
          {backLabel}
        </Button>
      )}

      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit?.(e);
        }}
        className="bg-white rounded-card shadow-card p-4 sm:p-6 lg:p-8"
      >
        <div className="space-y-4 sm:space-y-6">{children}</div>

        {(onSubmit || onCancel) && (
          <div className="flex flex-col-reverse sm:flex-row gap-2 sm:gap-3 mt-6 pt-6 border-t border-gray-100">
            {onCancel && (
              <Button variant="outline" onClick={onCancel} className="sm:w-auto w-full">
                {cancelLabel}
              </Button>
            )}
            {onSubmit && (
              <Button
                type="submit"
                loading={loading}
                className="sm:w-auto w-full sm:ml-auto"
              >
                {submitLabel}
              </Button>
            )}
          </div>
        )}
      </form>
    </PageLayout>
  );
};

export const FormField = ({ label, required, error, children, className = '' }) => (
  <div className={className}>
    {label && (
      <label className="block text-sm font-medium text-secondary mb-1.5">
        {label}
        {required && <span className="text-danger ml-0.5">*</span>}
      </label>
    )}
    {children}
    {error && <p className="mt-1 text-xs text-danger">{error}</p>}
  </div>
);

export const DetailCard = ({ title, children, className = '' }) => (
  <div className={`bg-white rounded-card shadow-card p-4 sm:p-6 ${className}`}>
    {title && (
      <h2 className="text-lg font-semibold text-secondary mb-4 pb-3 border-b border-gray-100">
        {title}
      </h2>
    )}
    {children}
  </div>
);

export const DetailRow = ({ label, value, className = '' }) => (
  <div className={`flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4 py-3 border-b border-gray-50 last:border-0 ${className}`}>
    <span className="text-sm font-medium text-gray-500 sm:w-1/3 shrink-0">{label}</span>
    <span className="text-sm text-secondary sm:flex-1">{value ?? '-'}</span>
  </div>
);

export default FormLayout;
